<div class="alarm-details-content">
  <div class="details-card">
    <div class="card-header">
      <div class="header-top-row">
        <div class="header-title-block">
          <h2>Monitor de Riesgo</h2>
          <p>Información de última posición de los vehículos</p>
        </div>
        <div class="header-actions">
          <div class="cluster-toggle-wrapper">
            <i class="material-icons toggle-icon">{{ clusteringEnabled ? 'blur_on' : 'blur_off' }}</i>
            <span class="toggle-label">Clusters</span>
            <mat-slide-toggle [checked]="clusteringEnabled" (change)="onClusterToggle($event.checked)" color="primary">
            </mat-slide-toggle>
          </div>
        </div>
      </div>

      <!-- Fila de filtros -->
      @if (displayedPositions && displayedPositions.length > 0) {
        <div class="header-filters-row">
          <div class="filter-search-input">
            <i class="material-icons">search</i>
            <input type="text" placeholder="Buscar por placa, nombre, evento..." [(ngModel)]="filterText"
              (input)="applyFilters()" />
            @if (filterText) {
              <i class="material-icons filter-clear-icon" (click)="filterText = ''; applyFilters()">close</i>
            }
          </div>
          <button class="filter-toggle-btn" (click)="toggleFilters()" [class.active]="showFilters || hasActiveFilters">
            <i class="material-icons">directions_car</i>
            @if (selectedUnits.size > 0) {
              <span class="filter-active-dot"></span>
            }
          </button>
        </div>

        @if (hasActiveFilters) {
          <div class="header-filter-summary">
            <span class="filter-result-count">
              {{ filteredAlarms.length }} de {{ displayedPositions.length }} posiciones
            </span>
            <button class="filter-clear-btn" (click)="clearFilters()">
              <i class="material-icons">filter_list_off</i> Limpiar
            </button>
          </div>
        }

        <!-- Panel desplegable de unidades -->
        @if (showFilters) {
          <div class="unit-filter-panel">
            <div class="unit-filter-header">
              <span class="unit-filter-title">Filtrar por unidades ({{ availableUnits.length }})</span>
              <div class="unit-filter-actions">
                <button class="unit-action-btn" (click)="selectAllUnits()">Todas</button>
                <span class="unit-action-sep">|</span>
                <button class="unit-action-btn" (click)="deselectAllUnits()">Ninguna</button>
              </div>
            </div>
            <div class="unit-search-input">
              <i class="material-icons">search</i>
              <input type="text" placeholder="Buscar unidad..." [(ngModel)]="unitSearchText" />
            </div>
            <div class="unit-list">
              @for (unit of filteredUnits; track unit.assetId) {
                <label class="unit-item" [class.selected]="selectedUnits.has(unit.assetId)">
                  <input type="checkbox" [checked]="selectedUnits.has(unit.assetId)" (change)="toggleUnit(unit.assetId)" />
                  <span class="unit-name">{{ unit.assetName }}</span>
                  <span class="unit-plate">{{ unit.assetId }}</span>
                </label>
              }
              @if (filteredUnits.length === 0) {
                <div class="unit-empty">Sin unidades encontradas</div>
              }
            </div>
          </div>
        }
      }



    </div>
    <div class="divider"></div>

    <div class="card-content">
      <div class="alarm-info-grid">

        @if (displayedPositions.length === 0) {
          <div>No hay datos de última posición.</div>
        }

        @if (displayedPositions.length > 0) {
          @if (isRiskEvaluation) {
            <div class="cards-scroll-container" [class.stale-alert]="hasStalePositions()">
              @for (pos of (hasActiveFilters ? filteredAlarms : displayedPositions); track pos.assetId ? pos.assetId + '-' + $index : $index; let i = $index) {
                <div class="alarm-card-scroll" [style.border-left-color]="pos.color || '#172c41'"
                  (click)="onVehicleSelected(pos)" [title]="pos.assetNames || 'Vehículo'">
                  <div class="alarm-card-header">
                    <i class="material-icons alarm-card-icon" [style.color]="pos.color || '#172c41'">warning</i>
                    <span class="alarm-card-title">{{ pos.eventName || 'Evento' }}</span>
                    <span class="alarm-card-title alarm-card-risk" [style.color]="pos.color || '#172c41'">{{ pos.riskLabel ||
                    'Evaluación' }}({{ pos.riskEvaluation || '0' }})</span>
                  </div>
                  <div class="alarm-card-body">
                    <div class="alarm-card-row">
                      <i class="material-icons">local_shipping</i>
                      <span>{{ pos.assetName || 'N/A' }}</span>
                      <span class="alarm-card-plate">{{ pos.assetId || '' }}</span>
                    </div>
                    <div class="alarm-card-row">
                      <i class="material-icons">place</i>
                      <span class="alarm-card-location">{{ pos.location || 'Sin ubicación' }}</span>
                    </div>
                    <div class="alarm-card-row">
                      <i class="material-icons">schedule</i>
                      <span>{{ pos.reportDate | date:'dd/MM/yyyy HH:mm' }}</span>
                      @if (pos.speed != null) {
                        <span class="alarm-card-speed">
                          <i class="material-icons">speed</i> {{ pos.speed }} km/h
                        </span>
                      }
                    </div>
                    <div class="alarm-card-row" [class.stale-age]="isStale(pos)">
                      <i class="material-icons">schedule</i>
                      <span class="age-value">{{ formatAge(pos.reportDate, currentTime) }}</span>
                      <span class="alarm-card-location" [style.color]="pos.color || '#555'">Zona: {{ pos.zoneName || ''
                      }}</span>
                    </div>
                  </div>
                </div>
              }
            </div>
          }

          @if (!isRiskEvaluation) {
            <div class="table-scroll-container">
              <app-lastposicion-monitor [lastPositions]="lastPositions" [alarmsByAssetId]="alarmsByAssetId"
                [isRiskEvaluation]="isRiskEvaluation" [alarms]="alarms"
                (vehicleSelected)="onVehicleSelected($event)"
              (filteredAssetIdsChange)="filteredAssetIdsChange.emit($event)"></app-lastposicion-monitor>
            </div>
          }
        }
      </div>
    </div>
  </div>
</div>